// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ca-input{outline:none!important;border:none;width:100%;background:#242424;padding:3px 6px;color:inherit;height:24px;-webkit-box-sizing:border-box;box-sizing:border-box}.ca-input:hover{-webkit-box-shadow:var(--focus-ring-inactive-shadow);box-shadow:var(--focus-ring-inactive-shadow)}.ca-input:focus{-webkit-box-shadow:var(--focus-ring-active-shadow);box-shadow:var(--focus-ring-active-shadow)}", ""]);
// Exports
module.exports = exports;
